import { render, staticRenderFns } from "./SpaceSystem.vue?vue&type=template&id=b380b8b4&"
import script from "./SpaceSystem.vue?vue&type=script&lang=js&"
export * from "./SpaceSystem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports